export enum Facility {
	AIRCO = 'AIRCO',
	ALL_DOGS_ALLOWED = 'ALL_DOGS_ALLOWED',
	ANIMATION = 'ANIMATION',
	BAR_CAFE_CAFETARIA = 'BAR_CAFE_CAFETARIA',
	BAR_CAFETARIA_VENDING_MACHINE = 'BAR_CAFETARIA_VENDING_MACHINE',
	BIKES_FREE = 'BIKES_FREE',
	BIKES_PAID = 'BIKES_PAID',
	BUS_STOP_STATION_CLOSEBY = 'BUS_STOP_STATION_CLOSEBY',
	CARE = 'CARE',
	CHILD_FRIENDLY_FACILITIES = 'CHILD_FRIENDLY_FACILITIES',
	DISHWASHER = 'DISHWASHER',
	ELEVATOR = 'ELEVATOR',
	FITNESS = 'FITNESS',
	FREE_PARKING = 'FREE_PARKING',
	GROUP_ALLOWED = 'GROUP_ALLOWED',
	INDOOR_PLAYGROUND = 'INDOOR_PLAYGROUND',
	INDOOR_POOL_ALL_YEAR = 'INDOOR_POOL_ALL_YEAR',
	INDOOR_POOL_SEASONAL = 'INDOOR_POOL_SEASONAL',
	OUTDOOR_POOL_ALL_YEAR = 'OUTDOOR_POOL_ALL_YEAR',
	OUTDOOR_POOL_SEASONAL = 'OUTDOOR_POOL_SEASONAL',
	PAID_PARKING = 'PAID_PARKING',
	PARKING = 'PARKING',
	PICKNICK_AREA = 'PICKNICK_AREA',
	PICKNICK_POSSIBLE = 'PICKNICK_POSSIBLE',
	PLAYGROUND = 'PLAYGROUND',
	RELAXATION_AREA = 'RELAXATION_AREA',
	RESTAURANT = 'RESTAURANT',
	RESTAURANT_OR_SNACKBAR = 'RESTAURANT_OR_SNACKBAR',
	SHUTTLE_SERVICE_FREE = 'SHUTTLE_SERVICE_FREE',
	SHUTTLE_SERVICE_PAID = 'SHUTTLE_SERVICE_PAID',
	SWIMMING_POND = 'SWIMMING_POND',
	TELEVISION = 'TELEVISION',
	WASHING_MACHINE = 'WASHING_MACHINE',
	WELLNESS = 'WELLNESS',
	WHEEL_CHAIR_FREE = 'WHEEL_CHAIR_FREE',
	WHEEL_CHAIR_PAID = 'WHEEL_CHAIR_PAID',
	WHEELCHAIR_ACCESSIBLE = 'WHEELCHAIR_ACCESSIBLE',
	WIFI = 'WIFI',
}

export const FACILITIES_DAYTRIP = [
	Facility.BUS_STOP_STATION_CLOSEBY,
	Facility.BAR_CAFETARIA_VENDING_MACHINE,
	Facility.FREE_PARKING,
	Facility.PAID_PARKING,
	Facility.GROUP_ALLOWED,
	Facility.ALL_DOGS_ALLOWED,
	Facility.ELEVATOR,
	Facility.PICKNICK_POSSIBLE,
	Facility.RESTAURANT_OR_SNACKBAR,
	Facility.WHEEL_CHAIR_FREE,
	Facility.WHEEL_CHAIR_PAID,
];

export const FACILITIES_ACCOMMODATION = [
	Facility.ALL_DOGS_ALLOWED,
	Facility.ANIMATION,
	Facility.INDOOR_POOL_SEASONAL,
	Facility.INDOOR_POOL_ALL_YEAR,
	Facility.OUTDOOR_POOL_SEASONAL,
	Facility.OUTDOOR_POOL_ALL_YEAR,
	Facility.SWIMMING_POND,
	Facility.BUS_STOP_STATION_CLOSEBY,
	Facility.BIKES_FREE,
	Facility.BIKES_PAID,
	Facility.BAR_CAFE_CAFETARIA,
	Facility.RESTAURANT,
	Facility.FITNESS,
	Facility.CHILD_FRIENDLY_FACILITIES,
	Facility.ELEVATOR,
	Facility.RELAXATION_AREA,
	Facility.PARKING,
	Facility.SHUTTLE_SERVICE_FREE,
	Facility.SHUTTLE_SERVICE_PAID,
	Facility.INDOOR_PLAYGROUND,
	Facility.PLAYGROUND,
	Facility.TELEVISION,
	Facility.WELLNESS,
	Facility.WIFI,
	Facility.CARE,
	Facility.WASHING_MACHINE,
	Facility.DISHWASHER,
	Facility.AIRCO,
];

export const FACILITIES_ACCOMMODATION_FOR_FILTERS = [
	Facility.ALL_DOGS_ALLOWED,
	Facility.ANIMATION,
	'ALL_INDOOR_POOLS',
	// Facility.INDOOR_POOL_SEASONAL,
	// Facility.INDOOR_POOL_ALL_YEAR,
	'ALL_OUTDOOR_POOLS',
	// Facility.OUTDOOR_POOL_SEASONAL,
	// Facility.OUTDOOR_POOL_ALL_YEAR,
	// Facility.SWIMMING_POND,
	Facility.BUS_STOP_STATION_CLOSEBY,
	'ALL_BIKES',
	// Facility.BIKES_FREE,
	// Facility.BIKES_PAID,
	Facility.BAR_CAFE_CAFETARIA,
	Facility.RESTAURANT,
	Facility.FITNESS,
	Facility.CHILD_FRIENDLY_FACILITIES,
	Facility.ELEVATOR,
	Facility.RELAXATION_AREA,
	Facility.PARKING,
	'ALL_SHUTTLE_SERVICES',
	// Facility.SHUTTLE_SERVICE_FREE,
	// Facility.SHUTTLE_SERVICE_PAID,
	Facility.INDOOR_PLAYGROUND,
	Facility.PLAYGROUND,
	Facility.WELLNESS,
	Facility.CARE,
];
